module.exports = __webpack_public_path__ + "img/515.3f46c1ca.png";